export const TIMESTAMPS_DRAG_DROP_TYPE = 'TIMESTAMPS_DRAG_DROP_TYPE';

export interface TimestampDndItem {
  index: number | null;
  from: string;
  to: string;
  hourId?: number;
  fromY?: number;
  heightPx?: number;
}

export interface TimestampDragDropAction {
  timestamp: TimestampDndItem;
  incrementInMinutes: number;
}
